import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { DownOutlined, SettingOutlined } from "@ant-design/icons";
//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Spin,
  Form,
  Divider,
  Col,
  Collapse,
  Statistic,
  Table,
  Button,
  Dropdown,
  message,
  Space,
  Tooltip,
} from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";

import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import { apiConfig, labelConfig, staticConfig } from "../group.config";
import appStatic from "../../../config/appStatic";
import AccountsOverview from "../components/tabs/AccountsOverview";
import ManageMembers from "../components/tabs/ManageMembers";
import Notes from "../components/tabs/Notes";
import Committee from "../components/tabs/Committee";
import {
  GroupFacility,
  handleGroupDetailActionButtons,
  handleManageClientsActionButtons,
} from "../../../components/facilities/GroupFacility";
import {
  handleFlgStatus,
  accountStatus,
} from "../../../components/facilities/AccountFacility";
import { rightAction } from "../../../redux/actions";
import Notiflix from "notiflix";

const { Text, Title } = Typography;
const { Panel } = Collapse;

const DetailGroup = (props) => {
  //DECLARED VARIABLES
  const { userData, loanTableList, rightAction } = props;
  const { session } = userData;
  const { monthList } = appStatic;
  const navigate = useNavigate();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [groupDetails, setGroupDetails] = useState([]);
  const [loansList, setLoansList] = useState([]);
  const [savingsList, setSavingsList] = useState([]);
  const [GSIMSavingsList, setGSIMSavingsList] = useState([]);
  const [GLIMLoansList, setGLIMLoansList] = useState([]);
  const [notesList, setNotesList] = useState([]);
  const [groupRolesList, setGroupRolesList] = useState([]);
  const [clientsList, setClientsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("accountsOverview");
  const [menuProps, setMenuProps] = useState({
    items: [],
  });
  const [manageClientsMenuProps, setManageClientsMenuProps] = useState({
    items: [],
  });
  const tabList = [
    {
      key: "accountsOverview",
      label: "Accounts Overview",
      disabled: false,

    },
    {
      key: "manageMembers",
      label: "Manage Members",
      disabled: false,

    },
    {
      key: "notes",
      label: "Notes",
      disabled: !BOM.HasPermission("READ_GROUPNOTE"),

    },
    {
      key: "committee",
      label: "Committee",
      disabled: false,

    }
  ];

  useEffect(() => {
    getDetailById();
    getAccountOverviewList();
    getGSIMAccountsList();
    getGLIMAccountsList();
    getNotesList();
  }, [refresh]);

  const getDetailById = () => {
    const params = {
      associations: "all",
    };

    const url = `${apiConfig.Groups}/${state.id}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setGroupDetails(objDetail);
        let tempGroupRolesList = [];
        let tempCLientsList = [];
        let tempStaffId = objDetail.staffId ? objDetail.staffId : "";

        objDetail?.groupRoles?.forEach((element) => {
          tempGroupRolesList.push({
            key: element?.id,
            id: element?.id,
            role: element?.role ? element?.role?.name : "-",
            name: element?.clientName ? element?.clientName : "-",
            clientId: element?.clientId ? element?.clientId : "-",
          });
        });

        objDetail?.clientMembers?.forEach((element) => {
          tempCLientsList.push({
            key: element?.id,
            id: element?.id,
            accountNo: element?.accountNo ? element?.accountNo : "-",
            name: element?.displayName ? element?.displayName : "-",
            status: handleFlgStatus(element?.status.value, {}, true, element),
          });
        });

        setGroupRolesList(tempGroupRolesList);
        setClientsList(tempCLientsList);
        /**
         * ON CLICK ACTION MENU
         */
        setMenuProps({
          items: handleGroupDetailActionButtons(objDetail),
          onClick: (e) => {
            const item = handleGroupDetailActionButtons(objDetail).find(
              (element) => element.key === e.key
            );

            if (item) {
              switch (item?.label.toLowerCase()) {
                case "unassign staff":
                  return UnAssignStaff(tempStaffId);

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      ...state,
                      accountNo: objDetail.accountNo,
                      actionLabel: item.label,
                    },
                  });
              }
            }
          },
        });

        /**
         * ACTIVATE DELETE RIGHT BUTTON ACTION
         */
        if (objDetail?.status?.value.toLowerCase() === accountStatus.submittedAndPending && BOM.HasPermission("DELETE_LOAN")) {
          rightAction(cnt.RIGHT_DELETE_BTN);
        }

        // ON CLICK MANAGE CLIENTS ACTION MENU
        setManageClientsMenuProps({
          items: handleManageClientsActionButtons(objDetail),
          onClick: (e) => {
            const item = handleManageClientsActionButtons(objDetail).find(
              (element) => element.key === e.key
            );

            if (item) {
              return navigate(item.route, {
                state: {
                  ...state,
                  accountNo: objDetail.accountNo,
                  actionLabel: item.label,
                },
              });
            }
          },
        });

        /**
         * STOP LOADER
         */
        setIsLoading(false);
      }
    });
  };

  const getAccountOverviewList = () => {
    const url = `${apiConfig.Groups}/${state.id}/accounts`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objDetail = res;

        let tempSavingsArray = [];
        let tempLoansArray = [];

        objDetail?.savingsAccounts?.forEach((element) => {
          tempSavingsArray.push({
            ...element,
            key: element?.id,
            id: element?.id,
            accountNo: element?.accountNo ? element?.accountNo : "-",
            productName: element?.productName ? element?.productName : "-",
            balance: element?.accountBalance ? element?.accountBalance : "-",
            actions: element?.actions ? element?.actions : "-",
            accounStatus: handleFlgStatus(
              element?.status?.value,
              {},
              true,
              element
            ),
          });
        });

        objDetail?.loanAccounts?.forEach((element) => {
          tempLoansArray.push({
            ...element,
            key: element?.id,
            id: element?.id,
            accountNo: element?.accountNo ? element?.accountNo : "-",
            productName: element?.productName ? element?.productName : "-",
            originalLoan: element?.originalLoan ? element?.originalLoan : "-",
            loanBalance: element?.loanBalance ? element?.loanBalance : "-",
            amountPaid: element?.amountPaid ? element?.amountPaid : "-",
            type: element?.loanType ? element?.loanType.value : "-",
            actions: element?.actions ? element?.actions : "-",
            accountStatus: handleFlgStatus(
              element?.status?.value,
              {},
              true,
              element
            ),
          });
        });

        setLoansList(tempLoansArray);
        setSavingsList(tempSavingsArray);
      }
    });
  };

  const getGSIMAccountsList = () => {
    const url = `${apiConfig.Groups}/${state.id}/gsimaccounts`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objDetail = res;

        let tempGSIMSavingsArray = [];

        objDetail?.forEach((element) => {
          tempGSIMSavingsArray.push({
            // ...element,
            key: element?.gsimId,
            gsimId: element?.gsimId,
            groupId: element?.groupId,
            accountNo: element?.accountNumber ? element?.accountNumber : "-",
            productName: element?.childGSIMAccounts[0]
              ? element?.childGSIMAccounts[0].productName
              : "-",
            balance: element?.parentBalance ? element?.parentBalance : "-",
            childGSIMAccountId: element?.childGSIMAccounts[0]
              ? element?.childGSIMAccounts[0].id
              : "-",
            accountStatus: handleFlgStatus(
              element?.savingsStatus,
              {},
              true,
              element
            ),
          });
        });

        setGSIMSavingsList(tempGSIMSavingsArray);
      }
    });
  };

  const getGLIMAccountsList = () => {
    const url = `${apiConfig.Groups}/${state.id}/glimaccounts`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objDetail = res;

        let tempGLIMLoansArray = [];

        objDetail?.forEach((element) => {
          tempGLIMLoansArray.push({
            ...element,
            key: element?.id,
            id: element?.glimId,
            accountNo: element?.accountNumber ? element?.accountNumber : "-",
            productName: element?.childGLIMAccounts[0]
              ? element?.childGLIMAccounts[0].productName
              : "-",
            originalLoan: element?.parentPrincipalAmount
              ? element?.parentPrincipalAmount
              : "-",
            status: handleFlgStatus(element?.loanStatus, {}, true, element),
          });
        });

        setGLIMLoansList(tempGLIMLoansArray);
      }
    });
  };

  const getNotesList = () => {

    const url = `${apiConfig.Groups}/${state.id}/notes`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err && err.errors[0].defaultUserMessage.toLowerCase() !== "user has no authority to read groupnotes") {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objDetail = res;

        let tempNotesArray = [];

        objDetail?.forEach((element) => {
          tempNotesArray.push({
            key: element?.id,
            resourceId: element?.id,
            createdBy: element?.createdByUsername
              ? element?.createdByUsername
              : "-",
            note: element?.note ? element?.note : "-",
            createdOn: element?.createdOn ? element?.createdOn : "-",
          });
        });

        setNotesList(tempNotesArray);
      }
    });
  };

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  //OTHER GROUP ACTION
  const handleOnDelete = () => {
    let action = "Delete Account  ";
    let accountNo = groupDetails.accountNo;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + accountNo,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.Groups}/${state.id}`;
        let body = {
          session,
          method: "DELETE",
        };
        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteCustomerGroupMsg);
            navigate("/manage-group");
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  };

  function UnAssignStaff(staffId) {
    setIsLoading(true);
    const params = {
      command: "unassignstaff",
    };
    const url = `${apiConfig.Groups}/${state.id}`;

    let body = {
      staffId: staffId,
      session,
      params,
      method: "POST",
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.unssignGroupOfficerMsg);
        //STOP LOAD
        setRefresh((prev) => !prev);
        setIsLoading(false);
      }
    });
  }

  const contentListNoTitle = {
    accountsOverview: (
      <AccountsOverview
        groupDetails={groupDetails}
        loansList={loansList}
        savingsList={savingsList}
        GSIMSavingsList={GSIMSavingsList}
        GLIMLoansList={GLIMLoansList}
        state={state}
      />
    ),
    manageMembers: (
      <ManageMembers
        groupDetails={groupDetails}
        manageClientsMenuProps={manageClientsMenuProps}
        clientsList={clientsList}
      />
    ),
    notes:
      <Notes
        groupDetails={groupDetails}
        notesList={notesList}
        state={state}
        session={session}
        getNotesList={getNotesList}
      />
    ,
    committee: (
      <Committee
        groupDetails={groupDetails}
        state={state}
        session={session}
        groupRolesList={groupRolesList}
        setGroupRolesList={setGroupRolesList}
      />
    ),
  };

  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailGroup}
        pageItems={staticConfig.detailGroupBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />

            <Row style={{ marginBottom: 30, padding: 10 }}>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <GroupFacility
                  accountName={groupDetails?.name}
                  accountNo={groupDetails?.accountNo}
                  officeName={groupDetails?.officeName}
                  centerName={groupDetails?.centerName}
                  status={groupDetails?.status}
                  accDetail={groupDetails}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <GroupDetails groupDetails={groupDetails} />
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <MeetingSchedule groupDetails={groupDetails} />
              </Col>
            </Row>
          </Form>
        </Card>
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 24,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(DetailGroup);

function GroupDetails(props) {
  const { groupDetails } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.accountInformation}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.activationDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {BOM.FormatArrayDate(groupDetails?.activationDate)}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.center}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {groupDetails?.centerName}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.relationshipManager}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {groupDetails?.staffName ? groupDetails?.staffName : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.activeClients}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {/* {groupDetails?.activeClientMembers} */}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.activeGroupLoans}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {groupDetails?.activeGroupLoans}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.activeClientLoans}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {groupDetails?.activeClientLoans}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.ActiveGroupBorrowers}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {groupDetails?.ActiveGroupBorrowers}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.activeClientBorrowers}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {groupDetails?.activeClientBorrowers}
              </Text>
            </Col>
          </Row>
        </div>

        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.activeOverdueGroupLoans}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {groupDetails?.activeOverdueGroupLoans}
              </Text>
            </Col>
          </Row>
        </div>

        <div
          style={{
            border: "2px #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.activeOverdueClientLoans}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {groupDetails?.activeOverdueClientLoans}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}

function MeetingSchedule(props) {
  const { groupDetails } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.meetings}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.nextMeetingOn}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {BOM.FormatArrayDate(
                  groupDetails?.collectionMeetingCalendar
                    ?.recentEligibleMeetingDate
                )}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.meetingFrequency}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {groupDetails?.collectionMeetingCalendar?.humanReadable}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}
